import type { ReactNode } from "react"
import { useRef } from "react"
import cn from "clsx"
import { useUnit } from "effector-react"
import { $callcenterService, $userService } from "@callcenter/effector-services"
import { UIBlockerService } from "@callcenter/services"

import { Time, Logo } from "../../components"
import { useHeaderScroll } from "./header.hooks"
import { UserProfile } from "../user-profile"
import { NavigationDesktop } from "../navigation-desktop"
import { NavigationMobile, NavigationMobileToggle } from "../navigation-mobile"
import { CallButton } from "../call-button"
import { NavigationAdmin } from "../navigation-admin"
import { TopHeaderModules } from "../top-header-modules"
import { useAgentStatus } from "../../shared/hooks"

import styles from "./header.module.pcss"

type Props = {
  kind?: "callcenter" | "omni"
  statusSwitcher?: ReactNode
}

export const Header = ({ kind = "callcenter", statusSwitcher }: Props) => {
  const userSettings = useUnit($userService.$userSettings)
  const isShowTimezone = useUnit($callcenterService.$settings).show_timezone_in_header
  const { status, uiState } = useAgentStatus()
  const isScrolled = useHeaderScroll()
  const headerRef = useRef<HTMLElement>(null)

  const isCallcenter = kind === "callcenter"
  const isBlockedContent = UIBlockerService.getBlockedPermission(userSettings)
  const isShowMenu = isCallcenter && !isBlockedContent

  return (
    <header ref={headerRef} className={cn(styles.header, { [styles.scrolled]: isScrolled })}>
      {isCallcenter && <TopHeaderModules />}
      <div className={cn(styles.container, { [styles.restricted]: isCallcenter })}>
        <Logo href={isShowMenu ? "/" : undefined} />
        {isShowMenu && <NavigationDesktop />}
        {isShowMenu && <NavigationAdmin />}
        <div className={styles.controls}>
          <Time isShowTimezone={isShowTimezone} />
          {statusSwitcher}
          <div className={styles.actionsContainer}>
            {isShowMenu && <CallButton />}
            <UserProfile status={status} uiState={uiState} popupTopPosition="45px" />
          </div>
          {isShowMenu && <NavigationMobileToggle />}
        </div>
        {isShowMenu && <NavigationMobile headerRef={headerRef} />}
      </div>
    </header>
  )
}
